import React, { useState } from 'react'
import UploadPDF from '../../../components/upload/upload'
import { Col, message, Row, Spin, Tooltip } from 'antd'
import { postAiUploadFileUrl, uploadResume, uploadResumeS3Url } from '../service/candidate.service'
import { useDispatch, useSelector } from 'react-redux'
import { candidateById, clearCandidateDetails, setCandidateId, setCandidateResumeUrl, setResumeFile } from '../store/candidate.slice'
import CandidateForm from './candidate-form'
import CandidatePfd from './candidate-pfd'
import { BackIcon } from '../../../assets/icons'
import { PRIVATE_ROUTES } from '../../../routes'
import { useNavigate } from 'react-router-dom'
import ManuallyCandidateAdd from './manually-candidate-add'



const AddCandidate = () => {
    const dispatch = useDispatch()
    const [fileUrl, setFileUrl] = useState(null)
    const [loading, setLoading] = useState(false)
    const { isLoading } = useSelector((state) => state.candidateSlice)
    const [openManuallyModel, setOpenManuallyModel] = useState(false)

    const navigate = useNavigate()
    const handleUploadPdf = async (file) => {
        try {
            const payload = {
                data: [
                    {
                        filename: file.file.name,
                        contentType: file.file.type
                    }
                ]

            }
            const { data } = await uploadResume(payload)
            if (data.success) {

                uploadFileS3Url(file.file, data.data[0].uploadUrl, data.data[0].publicLink, file.file.name)
            }

        } catch (error) {
            console.log("🚀 ~ handleUploadPdf ~ error:", error)

        }
    }


    const uploadFileS3Url = async (file, uploadUrl, publicUrl, fileName) => {
        try {
            const data = await uploadResumeS3Url(file, uploadUrl)
            if (data.status === 200) {
                handleAiUploadUrl(publicUrl, "application/pdf", fileName, file)
            }

        } catch (error) {
            console.log("🚀 ~ uploadFileS3Url ~ error:", error)

        }
    }




    const handleAiUploadUrl = async (url, type, fileName, file) => {
        try {
            const payload = {
                resumeUrl: url,
                fileType: type,
                fileName: fileName
            }
            const { data } = await postAiUploadFileUrl(payload)
            if (data.success) {
                setFileUrl(url)
                const id = data?.data?._id
                dispatch(candidateById({ id, activeTab: "OVERVIEW" }))
                dispatch(setCandidateId(id))
            } else if (data.message === "Candidate already exists with this email") {
                setFileUrl(null)
                setLoading(false)
                message.error(data.message)
            } else if (data.message === "Email is not present in resume, check resume file and try again") {
                setFileUrl(url)
                console.log(url, "url");

                dispatch(setCandidateId(null))
                dispatch(clearCandidateDetails())
                dispatch(setResumeFile(file))
                dispatch(setCandidateResumeUrl(url))
                setLoading(false)
                message.error(data.message)

            }

        } catch (error) {
            console.log("🚀 ~ handleAiUploadUrl ~ error:", error)

        }
    }
    const handleBackToList = () => {
        navigate(PRIVATE_ROUTES.candidate.root)
    }

    return (
        <div>
            {fileUrl ? (
                <>
                    <Spin spinning={isLoading ? true : false}>
                        <div>
                            <div style={{ display: "flex", justifyContent: "end" }}>
                                <Tooltip title="Back">

                                    <div
                                        style={{
                                            height: '30px',
                                            width: '30px',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => navigate(PRIVATE_ROUTES.candidate.root)}
                                    >
                                        <BackIcon />
                                    </div>
                                </Tooltip>
                            </div>
                        </div>
                        <Row gutter={[25, 20]}>
                            <Col xs={24} sm={12} md={13} lg={13} xl={13} style={{ height: "100%", overflow: "auto" }}>
                                <div ><CandidatePfd pdfUrl={fileUrl} /></div>
                            </Col>
                            <Col xs={24} sm={12} md={11} lg={11} xl={11}>
                                <CandidateForm />
                            </Col>
                        </Row>
                    </Spin>

                </>
            ) : (
                <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100vh',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <div className='upload_resume' style={{ margin: '15px 0px' }}>
                            <UploadPDF onChnage={handleUploadPdf} loading={loading} setLoading={setLoading} />
                        </div>
                        <button
                            style={{
                                backgroundColor: 'transparent',
                                color: '#1677ff',
                                border: 'none',
                                borderRadius: '5px',
                                padding: '10px 20px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                // marginTop: '10px',
                            }}
                            className="back-to-list-candidate-create-btn"
                            onClick={() => setOpenManuallyModel(true)}
                        >
                            Add Candidate Manually
                        </button>
                        <button
                            style={{
                                backgroundColor: 'transparent',
                                color: '#1677ff',
                                border: 'none',
                                borderRadius: '5px',
                                padding: '10px 20px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                // marginTop: '10px',
                            }}
                            className="back-to-list-candidate-create-btn"
                            onClick={handleBackToList}
                        >
                            Back To List
                        </button>


                    </div>
                </div>
            )}

            {openManuallyModel && <ManuallyCandidateAdd openManuallyModel={openManuallyModel} setOpenManuallyModel={setOpenManuallyModel} />}

        </div>
    )
}

export default AddCandidate
